import React from "react";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import NotFoundImg from "src/images/empty-state-no-user-found.svg";
import { EmptyTabContainer } from "./EmptyTabContainer/EmptyTabContainer";
import { EmptyTabContent } from "./EmptyTabContent/EmptyTabContent";

export default function ProfileSocialProviderNotCrawlable() {
  return (
    <EmptyTabContainer className="empty-social-profiles-tab">
      <EmptyTabContent
        header={
          <IDHFormattedMessage
            id="ws_profile_data_not_crawlable"
            defaultMessage="Platform not supported yet"
          />
        }
        imgUrl={NotFoundImg}
      />
    </EmptyTabContainer>
  );
}
